import { render, staticRenderFns } from "./BushAppeal.vue?vue&type=template&id=62454f1a&scoped=true"
import script from "./BushAppeal.vue?vue&type=script&lang=js"
export * from "./BushAppeal.vue?vue&type=script&lang=js"
import style0 from "./BushAppeal.vue?vue&type=style&index=0&id=62454f1a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62454f1a",
  null
  
)

export default component.exports